import {
  cloneElement,
  useState,
  type FC,
  type FocusEvent,
  type MouseEvent,
  type ReactElement,
} from "react";
import { Tooltip } from "@mui/material";
import { isTruncated } from "../model/isTruncated";

interface ChildProps {
  onMouseOver?: (event: MouseEvent<HTMLElement>) => void;
  onFocus?: (event: FocusEvent<HTMLElement>) => void;
}

/**
 * Подсказка с полным текстом только когда текст действительно обрезан
 * (финальное ревью, минор 2): короткое название без многоточия подсказку
 * не показывает. Замер при наведении и фокусе, до того как Tooltip решит
 * открыться (MUI сначала зовёт обработчик ребёнка).
 */
export const OverflowTooltip: FC<{
  title: string;
  describeChild?: boolean;
  children: ReactElement<ChildProps>;
}> = ({ title, describeChild, children }) => {
  const [truncated, setTruncated] = useState(false);
  return (
    <Tooltip title={truncated ? title : ""} describeChild={describeChild}>
      {cloneElement(children, {
        onMouseOver: (event: MouseEvent<HTMLElement>) => {
          setTruncated(isTruncated(event.currentTarget));
          children.props.onMouseOver?.(event);
        },
        onFocus: (event: FocusEvent<HTMLElement>) => {
          setTruncated(isTruncated(event.currentTarget));
          children.props.onFocus?.(event);
        },
      })}
    </Tooltip>
  );
};
